<template>
	<transition name="digit" mode="out-in">
		<div :key="digit" class="digit">{{digit}}</div>
	</transition>
</template>

<script>
	export default {
		name: "ClockDigit",
		props: {
			digit: {
				default: "",
			},
		}
	}
</script>

<style scoped>
	.digit {
		display: inline-block;
		font-size: 42px;
	}

	.digit-enter-active, .digit-leave-active {
		transition: all 0.2s;
	}

	.digit-enter {
		opacity: 0;
		transform: translateY(30px);
	}

	.digit-leave-to {
		opacity: 0;
		transform: translateY(-30px);
	}
</style>